import React, { useEffect, useState } from "react";
import { CommonButton } from "./CommonButton";
import CarsImage from "../../../assets/svgIcons/CarIcon";
import StatisticsImage from "assets/svgIcons/FleetSideNavIcon/UsageIcon";
import EnvelopeImage from "assets/svgIcons/FleetSideNavIcon/ScorecardsIcon";
import SettingsImage from "assets//svgIcons/SideNav/Settings";
import { getFeatureSetOption, getFeaturesList } from "../../../constant";
import { CommonHeading } from "./CommonHeading";
import { useHookstate } from "@hookstate/core";
import { useSelector } from "react-redux";
import {
  MAP_GLOBAL_STATES,
  FLEET_GLOBAL_STATES,
} from "globalStore/globalStore";
import { useLocation, useNavigate } from "react-router-dom";
import { SubSideNavTabs } from "commonComponents/SideNav/subSideNav/subSideNavStyled";
import { Badge, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";

export const FleetSideNav = () => {
  const { t } = useTranslation();
  const { mapSideNavTabState } = useHookstate(MAP_GLOBAL_STATES);
  const { badgeCount } = useHookstate(FLEET_GLOBAL_STATES);
  const [showComponent, setShowComponent] = useState(true);
  const { siteSettingsData } =
    useSelector((state) => state?.commonReducers) || [];

  useEffect(() => {
    let getSubnavName = localStorage.getItem("mapSideNavTabState");
    if (
      getSubnavName === "Cars" ||
      getSubnavName === "Usage" ||
      getSubnavName === "Scorecards" ||
      getSubnavName === "Settings"
    ) {
      mapSideNavTabState.set(localStorage.getItem("mapSideNavTabState"));
    } else {
      mapSideNavTabState.set("Cars");
      localStorage.setItem("mapSideNavTabState", "Cars");
    }
  }, []);

  return (
    <div>
      {showComponent && (
        <div>
          <CommonHeading labelText={"Fleet"} />
          <SubSideNavTabs>
            <Badge
              badgeContent={badgeCount.value}
              color="error"
            >
              <Tooltip title={t("Cars")} arrow>
                <span>
                  <CommonButton
                    labelText="Cars"
                    displayText={"Cars"}
                    changeSideNavData={() => {
                      // badgeCount.set(0);
                      localStorage.setItem("mapSideNavTabState", "Cars");
                      mapSideNavTabState.set("Cars");
                    }}
                  >
                    <CarsImage
                      width={25}
                      height={17}
                      color={
                        mapSideNavTabState.get() === "Cars"
                          ? "var(--theme-text)"
                          : "var(--text-secondary)"
                      }
                    />
                  </CommonButton>
                </span>
              </Tooltip>
            </Badge>
            <Tooltip title={t("Usage")} arrow>
              <span>
                <CommonButton
                  labelText="Usage"
                  displayText={"Usage"}
                  changeSideNavData={() => {
                    localStorage.setItem("mapSideNavTabState", "Usage");
                    mapSideNavTabState.set("Usage");
                  }}
                >
                  <StatisticsImage
                    color={
                      mapSideNavTabState.get() === "Usage"
                        ? "var(--theme-text)"
                        : "var(--text-secondary)"
                    }
                  />
                </CommonButton>
              </span>
            </Tooltip>

            <Tooltip title={t("Scorecards")} arrow>
              <span className="Scorecards">
                <CommonButton
                  disabled={getFeatureSetOption(
                    siteSettingsData &&
                      siteSettingsData !== null &&
                      siteSettingsData?.Features,
                    getFeaturesList().real_time_tracking,
                    getFeaturesList().golfer_experience
                  )}
                  labelText="Scorecards"
                  displayText={"Scorecards"}
                  changeSideNavData={() => {
                    localStorage.setItem("mapSideNavTabState", "Scorecards");
                    mapSideNavTabState.set("Scorecards");
                  }}
                >
                  <EnvelopeImage
                    color={
                      mapSideNavTabState.get() === "Scorecards"
                        ? "var(--theme-text)"
                        : "var(--text-secondary)"
                    }
                  />
                </CommonButton>
              </span>
            </Tooltip>

            <Tooltip title={t("Settings")} arrow>
              <span>
                <CommonButton
                  labelText="Settings"
                  displayText={"Settings"}
                  changeSideNavData={() => {
                    localStorage.setItem("mapSideNavTabState", "Settings");
                    mapSideNavTabState.set("Settings");
                  }}
                >
                  <SettingsImage
                    color={
                      mapSideNavTabState.get() === "Settings"
                        ? "var(--theme-text)"
                        : "var(--text-secondary)"
                    }
                  />
                </CommonButton>
              </span>
            </Tooltip>
          </SubSideNavTabs>
        </div>
      )}
    </div>
  );
};
